import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import SiteLayout from "@/components/site/SiteLayout";
import { ProtectedRoute } from "@/components/site/ProtectedRoute";

import Home from "@/pages/Home";
import Utenze from "@/pages/Utenze";
import Credito from "@/pages/Credito";
import Assicurazioni from "@/pages/Assicurazioni";
import Piano from "@/pages/Piano";
import Login from "@/pages/Login";
import Registrazione from "@/pages/Registrazione";
import PasswordDimenticata from "@/pages/PasswordDimenticata";
import ResetPassword from "@/pages/ResetPassword";
import Termini from "@/pages/legal/Termini";
import Privacy from "@/pages/legal/Privacy";
import Cookie from "@/pages/legal/Cookie";

import AreaLayout from "@/area/AreaLayout";
import Dashboard from "@/area/Dashboard";
import Pratiche from "@/area/Pratiche";
import Richieste from "@/area/Richieste";
import Documenti from "@/area/Documenti";
import Messaggi from "@/area/Messaggi";
import PianoCliente from "@/area/PianoCliente";
import PraticaDetail from "@/area/PraticaDetail";
import AreaCredito from "@/area/AreaCredito";
import AssistenzaStradale from "@/area/AssistenzaStradale";

import { AdminRoute } from "@/admin/AdminRoute";
import AdminLayout from "@/admin/AdminLayout";
import AdminDashboard from "@/admin/AdminDashboard";
import AdminRequests from "@/admin/AdminRequests";
import AdminRequestDetail from "@/admin/AdminRequestDetail";
import AdminClients from "@/admin/AdminClients";
import AdminMessages from "@/admin/AdminMessages";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/utenze" element={<Utenze />} />
              <Route path="/credito" element={<Credito />} />
              <Route path="/assicurazioni" element={<Assicurazioni />} />
              <Route path="/piano" element={<Piano />} />
              <Route path="/termini" element={<Termini />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/cookie" element={<Cookie />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/registrazione" element={<Registrazione />} />
            <Route path="/password-dimenticata" element={<PasswordDimenticata />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/area"
              element={
                <ProtectedRoute>
                  <AreaLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="pratiche" element={<Pratiche />} />
              <Route path="pratiche/:id" element={<PraticaDetail />} />
              <Route path="richieste" element={<Richieste />} />
              <Route path="documenti" element={<Documenti />} />
              <Route path="messaggi" element={<Messaggi />} />
              <Route path="piano" element={<PianoCliente />} />
              <Route path="credito" element={<AreaCredito />} />
              <Route path="assistenza-stradale" element={<AssistenzaStradale />} />
            </Route>
            <Route
              path="/admin"
              element={
                <AdminRoute>
                  <AdminLayout />
                </AdminRoute>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="richieste" element={<AdminRequests />} />
              <Route path="richieste/:id" element={<AdminRequestDetail />} />
              <Route path="clienti" element={<AdminClients />} />
              <Route path="messaggi" element={<AdminMessages />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
